import { PINNED_HORIZONTAL_SCROLL_LAYOUT_CONSTANTS } from '@modules/profile/component/marketing-page-layout-container/pinned-horizontal-scroll-layout/pinned-horizontal-scroll-layout.constants';
import { COMPARISON_LAYOUT_CONSTANTS } from '@modules/profile/component/marketing-page-layout-container/comparison-layout/comparison-layout.constants';
import { COMPARISON_HERO_LAYOUT_CONSTANTS } from '@modules/profile/component/marketing-page-layout-container/comparison-hero-layout/comparison-hero-layout.constants';
import { COMPARISON_VALUE_GRID_LAYOUT_CONSTANTS } from '@modules/profile/component/marketing-page-layout-container/comparison-value-grid-layout/comparison-value-grid-layout.constants';
import { COMPARISON_FEATURE_SECTION_LAYOUT_CONSTANTS } from '@modules/profile/component/marketing-page-layout-container/comparison-feature-section-layout/comparison-feature-section-layout.constants';
import { COMPARISON_KEY_WINS_LAYOUT_CONSTANTS } from '@modules/profile/component/marketing-page-layout-container/comparison-key-wins-layout/comparison-key-wins-layout.constants';
import { COMPARISON_AUDIENCE_SUMMARY_LAYOUT_CONSTANTS } from '@modules/profile/component/marketing-page-layout-container/comparison-audience-summary-layout/comparison-audience-summary-layout.constants';
import { COMPARISON_FULL_TABLE_LAYOUT_CONSTANTS } from '@modules/profile/component/marketing-page-layout-container/comparison-full-table-layout/comparison-full-table-layout.constants';
import { PASSION_GRID_LAYOUT_CONSTANTS } from '@modules/profile/component/marketing-page-layout-container/passion-grid-layout/passion-grid-layout.constants';
import { FEATURE_LIST_IMAGE_LAYOUT_CONSTANTS } from '@modules/profile/component/marketing-page-layout-container/feature-list-image-layout/feature-list-image-layout.constants';
import { STATS_LAYOUT_CONSTANTS } from '@modules/profile/component/marketing-page-layout-container/stats-layout/stats-layout.constants';
import { MARKETING_COMPARISON_LAYOUT_PICKER_COPY } from '@modules/profile/component/marketing-page-layout-container/marketing-comparison-page-layouts.constants';
import { MARKETING_PRO_LAYOUT_PICKER_COPY } from '@modules/profile/component/marketing-page-layout-container/marketing-pro-page-layouts.constants';
import { FULL_PAGE_CAROUSEL_LAYOUT_CONSTANTS } from '@modules/profile/component/marketing-page-layout-container/full-page-carousel-layout/full-page-carousel-layout.constants';
import { EVENT_TICKETS_GRID_LAYOUT_CONSTANTS } from '@modules/profile/component/marketing-page-layout-container/event-tickets-grid-layout/event-tickets-grid-layout.constants';
import { EVENT_TICKETS_BANNER_LAYOUT_CONSTANTS } from '@modules/profile/component/marketing-page-layout-container/event-tickets-banner-layout/event-tickets-banner-layout.constants';
import { VIP_OFFERS_BANNER_LAYOUT_CONSTANTS } from '@modules/profile/component/marketing-page-layout-container/vip-offers-banner-layout/vip-offers-banner-layout.constants';
import { FEED_POSTS_GRID_LAYOUT_CONSTANTS } from '@modules/profile/component/marketing-page-layout-container/feed-posts-grid-layout/feed-posts-grid-layout.constants';
import {
  PORTFOLIO_ALBUM_DETAIL_LAYOUT_CONSTANTS,
  PORTFOLIO_DESCRIPTION_HORIZONTAL_CARD_LAYOUT_CONSTANTS,
  PORTFOLIO_DESCRIPTION_SIDEBAR_LIST_LAYOUT_CONSTANTS,
  PORTFOLIO_DESCRIPTION_SPLIT_LAYOUT_CONSTANTS,
  PORTFOLIO_DESCRIPTION_VERTICAL_CARD_LAYOUT_CONSTANTS,
  PORTFOLIO_ITEMS_GRID_LAYOUT_CONSTANTS
} from '@modules/profile/component/marketing-page-layout-container/portfolio-layout/portfolio-layout.constants';
import { FREE_FORM_LAYOUT_CONSTANTS } from '@modules/profile/component/marketing-page-layout-container/free-form-layout/free-form-layout.constants';

export interface MarketingPageSectionLayout {
  id: string;
  label: string;
  imagePath: string;
  description?: string;
}

export const LAYOUT_IDS = {
  PINNED_HORIZONTAL_SCROLL_LAYOUT: 'pinned-horizontal-scroll-layout',
  HERO_LAYOUT: 'hero-layout',
  FULL_PAGE_CAROUSEL_LAYOUT: FULL_PAGE_CAROUSEL_LAYOUT_CONSTANTS.LAYOUT_ID,
  IMAGE_RIGHT_LAYOUT: 'image-right-layout',
  IMAGE_LEFT_LAYOUT: 'image-left-layout',
  IMAGE_CAROUSEL_LAYOUT: 'image-carousel-layout',
  READ_MORE_LAYOUT: 'read-more-layout',
  FREE_FORM_LAYOUT: FREE_FORM_LAYOUT_CONSTANTS.LAYOUT_ID,
  NEWSLETTER_LAYOUT: 'newsletter-layout',
  STORE_ITEM_LAYOUT: 'store-item-layout',
  STORE_ITEMS_GRID_LAYOUT: 'store-items-grid-layout',
  EVENT_TICKETS_GRID_LAYOUT: EVENT_TICKETS_GRID_LAYOUT_CONSTANTS.LAYOUT_ID,
  EVENT_TICKETS_BANNER_LAYOUT: EVENT_TICKETS_BANNER_LAYOUT_CONSTANTS.LAYOUT_ID,
  VIP_OFFERS_BANNER_LAYOUT: VIP_OFFERS_BANNER_LAYOUT_CONSTANTS.LAYOUT_ID,
  FEED_POSTS_GRID_LAYOUT: FEED_POSTS_GRID_LAYOUT_CONSTANTS.LAYOUT_ID,
  PORTFOLIO_ALBUM_DETAIL_LAYOUT: PORTFOLIO_ALBUM_DETAIL_LAYOUT_CONSTANTS.LAYOUT_ID,
  PORTFOLIO_DESCRIPTION_SPLIT_LAYOUT: PORTFOLIO_DESCRIPTION_SPLIT_LAYOUT_CONSTANTS.LAYOUT_ID,
  PORTFOLIO_DESCRIPTION_VERTICAL_CARD_LAYOUT:
    PORTFOLIO_DESCRIPTION_VERTICAL_CARD_LAYOUT_CONSTANTS.LAYOUT_ID,
  PORTFOLIO_DESCRIPTION_HORIZONTAL_CARD_LAYOUT:
    PORTFOLIO_DESCRIPTION_HORIZONTAL_CARD_LAYOUT_CONSTANTS.LAYOUT_ID,
  PORTFOLIO_DESCRIPTION_SIDEBAR_LIST_LAYOUT:
    PORTFOLIO_DESCRIPTION_SIDEBAR_LIST_LAYOUT_CONSTANTS.LAYOUT_ID,
  PORTFOLIO_ITEMS_GRID_LAYOUT: PORTFOLIO_ITEMS_GRID_LAYOUT_CONSTANTS.LAYOUT_ID,
  CREATOR_POSTER_LAYOUT: 'creator-poster-layout',
  FEATURE_CREATOR_LAYOUT: 'feature-creator-layout',
  IMAGE_BOTTOM_LAYOUT: 'image-bottom-layout',
  STATS_LAYOUT: STATS_LAYOUT_CONSTANTS.LAYOUT_ID,
  BIG_FEATURE_LAYOUT: 'big-feature-layout',
  THREE_CARD_FEATURE_LAYOUT: 'three-card-feature-layout',
  THREE_CARD_VERTICAL_LAYOUT: 'three-card-vertical-layout',
  BANNER_CTA_LAYOUT: 'banner-cta-layout',
  HEADER_LAYOUT: 'header-layout',
  FOOTER_LAYOUT: 'footer-layout',
  IMAGE_LINEAR_GRID_LAYOUT: 'image-linear-grid-layout',
  LISTING_FEATURE_CAROUSEL_LAYOUT: 'listing-feature-carousel-layout',
  TESTIMONIAL_LAYOUT: 'testimonial-layout',
  TRUSTED_BRANDS_LAYOUT: 'trusted-brands-layout',
  VERTICAL_CARD_CAROUSEL_LAYOUT: 'vertical-card-carousel-layout',
  HERO_SIDE_IMAGE_LAYOUT: 'hero-side-image-layout',
  IMAGE_UPPER_LAYOUT: 'image-upper-layout',
  VERTICAL_CARD_SNAP_SCROLL_LAYOUT: 'vertical-card-snap-scroll-layout',
  COMPARISON_LAYOUT: COMPARISON_LAYOUT_CONSTANTS.LAYOUT_ID,
  COMPARISON_HERO_LAYOUT: COMPARISON_HERO_LAYOUT_CONSTANTS.LAYOUT_ID,
  COMPARISON_VALUE_GRID_LAYOUT: COMPARISON_VALUE_GRID_LAYOUT_CONSTANTS.LAYOUT_ID,
  COMPARISON_FEATURE_SECTION_LAYOUT: COMPARISON_FEATURE_SECTION_LAYOUT_CONSTANTS.LAYOUT_ID,
  COMPARISON_KEY_WINS_LAYOUT: COMPARISON_KEY_WINS_LAYOUT_CONSTANTS.LAYOUT_ID,
  COMPARISON_AUDIENCE_SUMMARY_LAYOUT: COMPARISON_AUDIENCE_SUMMARY_LAYOUT_CONSTANTS.LAYOUT_ID,
  COMPARISON_FULL_TABLE_LAYOUT: COMPARISON_FULL_TABLE_LAYOUT_CONSTANTS.LAYOUT_ID,
  PRO_HERO_LAYOUT: 'pro-hero-layout',
  PRO_SHOWCASE_SLIDER_LAYOUT: 'pro-showcase-slider-layout',
  PRO_FOUR_CARD_LAYOUT: 'pro-four-card-layout',
  PRO_CREATOR_GRID_LAYOUT: 'pro-creator-grid-layout',
  PRO_COMPARISON_TABLE_LAYOUT: 'pro-comparison-table-layout',
  PRO_CONTACT_FORM_LAYOUT: 'pro-contact-form-layout',
  IMAGE_UPPER_LOWER_LAYOUT: 'image-upper-lower-layout',
  PASSION_GRID_LAYOUT: 'passion-grid-layout',
  FEATURE_LIST_IMAGE_LAYOUT: 'feature-list-image-layout'
} as const;

export const LOCKED_MARKETING_PAGE_SECTION_LAYOUTS = {
  HEADER: {
    id: LAYOUT_IDS.HEADER_LAYOUT,
    name: 'Header',
    isSliderVisible: false
  },
  FOOTER: {
    id: LAYOUT_IDS.FOOTER_LAYOUT,
    name: 'Footer',
    isSliderVisible: true
  }
} as const;

export function isLockedSectionVisibilitySliderVisible(layoutId: string): boolean {
  const lockedSection = Object.values(LOCKED_MARKETING_PAGE_SECTION_LAYOUTS).find(
    (section) => section.id === layoutId
  );
  if (!lockedSection) {
    return true;
  }
  return lockedSection.isSliderVisible !== false;
}

export const LOCKED_MARKETING_PAGE_SECTION_LAYOUT_IDS = [
  LOCKED_MARKETING_PAGE_SECTION_LAYOUTS.HEADER.id,
  LOCKED_MARKETING_PAGE_SECTION_LAYOUTS.FOOTER.id
] as const;

export const MARKETING_PAGE_SECTION_FIELD_MESSAGES = {
  INFO_SUBHEADING_NEWLINE:
    'To start a new line in the preview, press Enter or type \\n (backslash then n).',
  LABEL_CTA_TEXT_2: 'Call to Action 2',
  LABEL_CTA_LINK_2: 'Call-to-Action Link 2',
  PLACEHOLDER_CTA_TEXT_2: 'Enter CTA 2',
  PLACEHOLDER_CTA_LINK_2: 'Add Link 2'
} as const;

export const MARKETING_PAGE_SECTION_LAYOUTS: MarketingPageSectionLayout[] = [
  {
    id: LAYOUT_IDS.HERO_LAYOUT,
    label: 'Hero Layout 1',
    imagePath: 'https://cdn-www.topfans.com/TopFans/1785240781669.png',
    description: 'Full-width hero section with heading, subheading and responsive hero images'
  },
  {
    id: LAYOUT_IDS.IMAGE_RIGHT_LAYOUT,
    label: 'Horizontal Side Image Section',
    imagePath: 'https://cdn-www.topfans.com/TopFans/1785500229569.png',
    description: 'Two-column section with text and CTAs on the left and one side image on the right'
  },
  {
    id: LAYOUT_IDS.IMAGE_LEFT_LAYOUT,
    label: 'Vertical Side Image Section',
    imagePath: 'https://cdn-www.topfans.com/TopFans/1785500590624.png',
    description: 'Two-column section with text and CTAs on the left and one side image on the right'
  },
  {
    id: LAYOUT_IDS.IMAGE_CAROUSEL_LAYOUT,
    label: 'Image Slider',
    imagePath: 'https://cdn-www.topfans.com/TopFans/1785500433046.png',
    description: 'Slider section for multiple images slides'
  },
  {
    id: LAYOUT_IDS.FULL_PAGE_CAROUSEL_LAYOUT,
    label: FULL_PAGE_CAROUSEL_LAYOUT_CONSTANTS.LAYOUT_LABEL,
    imagePath: FULL_PAGE_CAROUSEL_LAYOUT_CONSTANTS.LAYOUT_IMAGE_PATH,
    description: FULL_PAGE_CAROUSEL_LAYOUT_CONSTANTS.LAYOUT_DESCRIPTION
  },
  {
    id: LAYOUT_IDS.READ_MORE_LAYOUT,
    label: 'Read More Text Section',
    imagePath: 'https://cdn-www.topfans.com/TopFans/1785501130622.png',
    description: 'Text-focused section with expandable read-more content'
  },
  {
    id: LAYOUT_IDS.FREE_FORM_LAYOUT,
    label: FREE_FORM_LAYOUT_CONSTANTS.LAYOUT_LABEL,
    imagePath: FREE_FORM_LAYOUT_CONSTANTS.LAYOUT_IMAGE_PATH,
    description: FREE_FORM_LAYOUT_CONSTANTS.LAYOUT_DESCRIPTION
  },
  {
    id: LAYOUT_IDS.NEWSLETTER_LAYOUT,
    label: 'Newsletter Layout',
    imagePath: 'https://cdn-www.topfans.com/TopFans/1785308184224.png',
    description:
      'Newsletter signup banner with heading, description, email input and subscribe button'
  },
  {
    id: LAYOUT_IDS.STORE_ITEM_LAYOUT,
    label: 'Single Store Item Layout',
    imagePath: 'https://cdn-www.topfans.com/TopFans/1785500162428.png',
    description:
      'Two-column section with heading and CTA on one side and a selected store item preview on the other'
  },
  {
    id: LAYOUT_IDS.STORE_ITEMS_GRID_LAYOUT,
    label: 'Store Items Grid Layout',
    imagePath: 'https://cdn-www.topfans.com/TopFans/1785500100599.png',
    description:
      'Section heading with a wrapping grid of selected store item cards'
  },
  {
    id: LAYOUT_IDS.CREATOR_POSTER_LAYOUT,
    label: 'Creator Poster Cards',
    imagePath: 'https://cdn-www.topfans.com/TopFans/1774956831065.png',
    description: 'Sticky alternating creator poster cards with per-card CTAs'
  }
];

/** Portfolio section layouts (cover page CMS). */
export const MARKETING_PORTFOLIO_PAGE_LAYOUTS: MarketingPageSectionLayout[] = [
  {
    id: LAYOUT_IDS.PORTFOLIO_ALBUM_DETAIL_LAYOUT,
    label: PORTFOLIO_ALBUM_DETAIL_LAYOUT_CONSTANTS.LAYOUT_LABEL,
    imagePath: 'https://cdn-www.topfans.com/TopFans/1786085432359.png',
    description: PORTFOLIO_ALBUM_DETAIL_LAYOUT_CONSTANTS.LAYOUT_DESCRIPTION
  },
  {
    id: LAYOUT_IDS.PORTFOLIO_DESCRIPTION_SPLIT_LAYOUT,
    label: PORTFOLIO_DESCRIPTION_SPLIT_LAYOUT_CONSTANTS.LAYOUT_LABEL,
    imagePath: 'https://cdn-www.topfans.com/TopFans/1786085405105.png',
    description: PORTFOLIO_DESCRIPTION_SPLIT_LAYOUT_CONSTANTS.LAYOUT_DESCRIPTION
  },
  {
    id: LAYOUT_IDS.PORTFOLIO_DESCRIPTION_VERTICAL_CARD_LAYOUT,
    label: PORTFOLIO_DESCRIPTION_VERTICAL_CARD_LAYOUT_CONSTANTS.LAYOUT_LABEL,
    imagePath: 'https://cdn-www.topfans.com/TopFans/1786085340662.png',
    description: PORTFOLIO_DESCRIPTION_VERTICAL_CARD_LAYOUT_CONSTANTS.LAYOUT_DESCRIPTION
  },
  {
    id: LAYOUT_IDS.PORTFOLIO_DESCRIPTION_HORIZONTAL_CARD_LAYOUT,
    label: PORTFOLIO_DESCRIPTION_HORIZONTAL_CARD_LAYOUT_CONSTANTS.LAYOUT_LABEL,
    imagePath: 'https://cdn-www.topfans.com/TopFans/1786085474454.png',
    description: PORTFOLIO_DESCRIPTION_HORIZONTAL_CARD_LAYOUT_CONSTANTS.LAYOUT_DESCRIPTION
  },
  {
    id: LAYOUT_IDS.PORTFOLIO_DESCRIPTION_SIDEBAR_LIST_LAYOUT,
    label: PORTFOLIO_DESCRIPTION_SIDEBAR_LIST_LAYOUT_CONSTANTS.LAYOUT_LABEL,
    imagePath: 'https://cdn-www.topfans.com/TopFans/1786085297834.png',
    description: PORTFOLIO_DESCRIPTION_SIDEBAR_LIST_LAYOUT_CONSTANTS.LAYOUT_DESCRIPTION
  },
  {
    id: LAYOUT_IDS.PORTFOLIO_ITEMS_GRID_LAYOUT,
    label: PORTFOLIO_ITEMS_GRID_LAYOUT_CONSTANTS.LAYOUT_LABEL,
    imagePath: 'https://cdn-www.topfans.com/TopFans/1786085377243.png',
    description: PORTFOLIO_ITEMS_GRID_LAYOUT_CONSTANTS.LAYOUT_DESCRIPTION
  }
];

/** Feed section layouts (cover page CMS). */
export const MARKETING_FEED_PAGE_LAYOUTS: MarketingPageSectionLayout[] = [
  {
    id: LAYOUT_IDS.FEED_POSTS_GRID_LAYOUT,
    label: FEED_POSTS_GRID_LAYOUT_CONSTANTS.LAYOUT_LABEL,
    imagePath: 'https://cdn-www.topfans.com/TopFans/1785500100599.png',
    description: FEED_POSTS_GRID_LAYOUT_CONSTANTS.LAYOUT_DESCRIPTION
  }
];

/** Event ticketing section layouts (cover page CMS). */
export const MARKETING_EVENT_TICKETING_PAGE_LAYOUTS: MarketingPageSectionLayout[] = [
  {
    id: LAYOUT_IDS.EVENT_TICKETS_GRID_LAYOUT,
    label: EVENT_TICKETS_GRID_LAYOUT_CONSTANTS.LAYOUT_LABEL,
    imagePath: 'https://cdn-www.topfans.com/TopFans/1786084769342.png',
    description: EVENT_TICKETS_GRID_LAYOUT_CONSTANTS.LAYOUT_DESCRIPTION
  },
  {
    id: LAYOUT_IDS.EVENT_TICKETS_BANNER_LAYOUT,
    label: EVENT_TICKETS_BANNER_LAYOUT_CONSTANTS.LAYOUT_LABEL,
    imagePath: EVENT_TICKETS_BANNER_LAYOUT_CONSTANTS.LAYOUT_IMAGE_PATH,
    description: EVENT_TICKETS_BANNER_LAYOUT_CONSTANTS.LAYOUT_DESCRIPTION
  }
];

/** VIP deals section layouts (cover page CMS). */
export const MARKETING_VIP_OFFER_PAGE_LAYOUTS: MarketingPageSectionLayout[] = [
  {
    id: LAYOUT_IDS.VIP_OFFERS_BANNER_LAYOUT,
    label: VIP_OFFERS_BANNER_LAYOUT_CONSTANTS.LAYOUT_LABEL,
    imagePath: VIP_OFFERS_BANNER_LAYOUT_CONSTANTS.LAYOUT_IMAGE_PATH,
    description: VIP_OFFERS_BANNER_LAYOUT_CONSTANTS.LAYOUT_DESCRIPTION
  }
];

/** Layouts available on Marketing Listing Page only (Hero + Feature Creator + Image Bottom). */
export const MARKETING_LISTING_PAGE_LAYOUTS: MarketingPageSectionLayout[] = [
  {
    id: LAYOUT_IDS.HEADER_LAYOUT,
    label: 'Header Layout',
    imagePath: 'https://cdn-www.topfans.com/TopFans/1773207617155.png',
    description: 'Sticky site header with logo, menu links and two CTA buttons'
  },
  {
    id: LAYOUT_IDS.FOOTER_LAYOUT,
    label: 'Footer Layout',
    imagePath: 'https://cdn-www.topfans.com/TopFans/1773207617155.png',
    description: 'Site footer with logo, description, store links and two link columns'
  },
  ...MARKETING_PAGE_SECTION_LAYOUTS,
  {
    id: LAYOUT_IDS.FEATURE_CREATOR_LAYOUT,
    label: 'Feature Creator Layout',
    imagePath: 'https://cdn-www.topfans.com/TopFans/1785501728868.png',
    description: 'Featured creators section with heading and selectable creators'
  },
  {
    id: LAYOUT_IDS.IMAGE_BOTTOM_LAYOUT,
    label: 'Image Bottom Layout',
    imagePath: 'https://cdn-www.topfans.com/TopFans/1785239990251.png',
    description: 'Heading, subheading, CTA and single image at bottom'
  },
  {
    id: LAYOUT_IDS.STATS_LAYOUT,
    label: STATS_LAYOUT_CONSTANTS.LAYOUT_LABEL,
    imagePath: STATS_LAYOUT_CONSTANTS.LAYOUT_IMAGE_PATH,
    description: STATS_LAYOUT_CONSTANTS.LAYOUT_DESCRIPTION
  },
  {
    id: LAYOUT_IDS.BIG_FEATURE_LAYOUT,
    label: 'Two Feature Cards',
    imagePath: 'https://cdn-www.topfans.com/TopFans/1785501246018.png',
    description: 'Outer heading, subheading and two feature cards with images and CTAs'
  },
  {
    id: LAYOUT_IDS.THREE_CARD_FEATURE_LAYOUT,
    label: 'Three Feature Cards',
    imagePath: 'https://cdn-www.topfans.com/TopFans/1785501418134.png',
    description: 'Outer heading, subheading and three feature cards (2+1 grid) with images and CTAs'
  },
  {
    id: LAYOUT_IDS.THREE_CARD_VERTICAL_LAYOUT,
    label: 'Three Feature Cards With Tall Card',
    imagePath: 'https://cdn-www.topfans.com/TopFans/1785500402867.png',
    description: 'Three feature cards in a 2+1 grid with one taller highlighted card'
  },
  {
    id: LAYOUT_IDS.BANNER_CTA_LAYOUT,
    label: 'Banner CTA Layout',
    imagePath: 'https://cdn-www.topfans.com/TopFans/1785500688623.png',
    description: 'Full-width banner with centered text overlay and CTA button'
  },
  {
    id: LAYOUT_IDS.IMAGE_LINEAR_GRID_LAYOUT,
    label: 'Image Card Grid',
    imagePath: 'https://cdn-www.topfans.com/TopFans/1774943722136.png',
    description: 'Grid section with image cards and CTA buttons'
  },
  {
    id: LAYOUT_IDS.LISTING_FEATURE_CAROUSEL_LAYOUT,
    label: 'Feature Listing Carousel',
    imagePath: 'https://cdn-www.topfans.com/TopFans/1785500313115.png',
    description: 'Feature card carousel with heading, CTA, navigation and listing cards'
  },
  {
    id: LAYOUT_IDS.TESTIMONIAL_LAYOUT,
    label: 'Testimonials Carousel',
    imagePath: 'https://cdn-www.topfans.com/TopFans/1785500509634.png',
    description: 'Marquee of testimonial cards with profile links'
  },
  {
    id: LAYOUT_IDS.TRUSTED_BRANDS_LAYOUT,
    label: 'Image Marquee Layout',
    imagePath: 'https://cdn-www.topfans.com/TopFans/1774943857630.png',
    description: 'Scrolling marquee of brand logos'
  },
  {
    id: LAYOUT_IDS.VERTICAL_CARD_CAROUSEL_LAYOUT,
    label: 'Vertical Card Carousel',
    imagePath: 'https://cdn-www.topfans.com/TopFans/1774943922199.png',
    description: '3D carousel of vertical cards with images'
  },
  {
    id: LAYOUT_IDS.HERO_SIDE_IMAGE_LAYOUT,
    label: 'Hero Layout With Side Image',
    imagePath: 'https://cdn-www.topfans.com/TopFans/1785500533321.png',
    description:
      'Hero-style section with background image, optional side image (desktop/mobile), heading and CTAs'
  },
  {
    id: LAYOUT_IDS.IMAGE_UPPER_LAYOUT,
    label: 'Image Above Text',
    imagePath: 'https://cdn-www.topfans.com/TopFans/1785500022539.png',
    description:
      'Full-width background with centered content image, heading, subheading and single CTA'
  },
  {
    id: LAYOUT_IDS.IMAGE_UPPER_LOWER_LAYOUT,
    label: 'Image Above And Below Text',
    imagePath: 'https://cdn-www.topfans.com/TopFans/1785240581137.png',
    description:
      'Full-width background with upper and lower content images, heading, subheading and single CTA'
  },
  {
    id: LAYOUT_IDS.PINNED_HORIZONTAL_SCROLL_LAYOUT,
    label: PINNED_HORIZONTAL_SCROLL_LAYOUT_CONSTANTS.LAYOUT_LABEL,
    imagePath: PINNED_HORIZONTAL_SCROLL_LAYOUT_CONSTANTS.LAYOUT_IMAGE_PATH,
    description: PINNED_HORIZONTAL_SCROLL_LAYOUT_CONSTANTS.LAYOUT_DESCRIPTION
  },
  {
    id: LAYOUT_IDS.VERTICAL_CARD_SNAP_SCROLL_LAYOUT,
    label: 'Vertical Card Snap Scroll Layout',
    imagePath: 'https://cdn-www.topfans.com/TopFans/1785499967174.png',
    description:
      'Hero background image and scroll-driven slides with content and image columns; no highlighted border'
  },
  {
    id: LAYOUT_IDS.PASSION_GRID_LAYOUT,
    label: PASSION_GRID_LAYOUT_CONSTANTS.LAYOUT_LABEL,
    imagePath: PASSION_GRID_LAYOUT_CONSTANTS.LAYOUT_IMAGE_PATH,
    description: PASSION_GRID_LAYOUT_CONSTANTS.LAYOUT_DESCRIPTION
  },
  {
    id: LAYOUT_IDS.FEATURE_LIST_IMAGE_LAYOUT,
    label: FEATURE_LIST_IMAGE_LAYOUT_CONSTANTS.LAYOUT_LABEL,
    imagePath: FEATURE_LIST_IMAGE_LAYOUT_CONSTANTS.LAYOUT_IMAGE_PATH,
    description: FEATURE_LIST_IMAGE_LAYOUT_CONSTANTS.LAYOUT_DESCRIPTION
  }
];

/** Recommended section layouts for comparison landing pages (matches page wireframe order). */
const C = MARKETING_COMPARISON_LAYOUT_PICKER_COPY;

export const MARKETING_COMPARISON_PAGE_RECOMMENDED_LAYOUTS: MarketingPageSectionLayout[] =
  [
    {
      id: LAYOUT_IDS.COMPARISON_HERO_LAYOUT,
      label: C.HERO.label,
      imagePath: 'https://cdn-www.topfans.com/TopFans/1772540992701.png',
      description: C.HERO.description
    },
    {
      id: LAYOUT_IDS.COMPARISON_VALUE_GRID_LAYOUT,
      label: C.VALUE_GRID.label,
      imagePath: 'https://cdn-www.topfans.com/TopFans/1785240396852.png',
      description: C.VALUE_GRID.description
    },
    {
      id: LAYOUT_IDS.COMPARISON_FEATURE_SECTION_LAYOUT,
      label: C.FEATURE_SECTION.label,
      imagePath: 'https://cdn-www.topfans.com/TopFans/1773062003631.png',
      description: C.FEATURE_SECTION.description
    },
    {
      id: LAYOUT_IDS.COMPARISON_KEY_WINS_LAYOUT,
      label: C.KEY_WINS.label,
      imagePath: 'https://cdn-www.topfans.com/TopFans/1785240888642.png',
      description: C.KEY_WINS.description
    },
    {
      id: LAYOUT_IDS.COMPARISON_FULL_TABLE_LAYOUT,
      label: C.FULL_TABLE.label,
      imagePath: 'https://cdn-www.topfans.com/TopFans/1773062153831.png',
      description: C.FULL_TABLE.description
    },
    {
      id: LAYOUT_IDS.COMPARISON_AUDIENCE_SUMMARY_LAYOUT,
      label: C.AUDIENCE_SUMMARY.label,
      imagePath: 'https://cdn-www.topfans.com/TopFans/1785240055690.png',
      description: C.AUDIENCE_SUMMARY.description
    },
    {
      id: LAYOUT_IDS.TESTIMONIAL_LAYOUT,
      label: C.TESTIMONIAL.label,
      imagePath: 'https://cdn-www.topfans.com/TopFans/1774943781458.png',
      description: C.TESTIMONIAL.description
    }
  ];

const MARKETING_PAGE_SECTION_EXCLUDED_LAYOUT_IDS = [
  LAYOUT_IDS.COMPARISON_LAYOUT,
  LAYOUT_IDS.COMPARISON_HERO_LAYOUT,
  LAYOUT_IDS.COMPARISON_FEATURE_SECTION_LAYOUT,
  LAYOUT_IDS.COMPARISON_FULL_TABLE_LAYOUT,
  LAYOUT_IDS.PRO_COMPARISON_TABLE_LAYOUT
] as const;
const MARKETING_PAGE_SECTION_EXCLUDED_LAYOUT_ID_SET = new Set<string>(
  MARKETING_PAGE_SECTION_EXCLUDED_LAYOUT_IDS
);


/** Recommended section layouts for Pro landing pages (matches page wireframe order). */
const P = MARKETING_PRO_LAYOUT_PICKER_COPY;

export const MARKETING_PRO_PAGE_RECOMMENDED_LAYOUTS: MarketingPageSectionLayout[] =
  [
    {
      id: LAYOUT_IDS.PRO_HERO_LAYOUT,
      label: P.HERO.label,
      imagePath: 'https://cdn-www.topfans.com/TopFans/1785239358041.png',
      description: P.HERO.description
    },
    {
      id: LAYOUT_IDS.PRO_FOUR_CARD_LAYOUT,
      label: P.FOUR_CARD.label,
      imagePath: 'https://cdn-www.topfans.com/TopFans/1785240562559.png',
      description: P.FOUR_CARD.description
    },
    {
      id: LAYOUT_IDS.PRO_SHOWCASE_SLIDER_LAYOUT,
      label: P.SHOWCASE_SLIDER.label,
      imagePath: 'https://cdn-www.topfans.com/TopFans/1785239263506.png',
      description: P.SHOWCASE_SLIDER.description
    },
    {
      id: LAYOUT_IDS.PRO_COMPARISON_TABLE_LAYOUT,
      label: P.COMPARISON_TABLE.label,
      imagePath: 'https://cdn-www.topfans.com/TopFans/1773062153831.png',
      description: P.COMPARISON_TABLE.description
    },
    {
      id: LAYOUT_IDS.PRO_CREATOR_GRID_LAYOUT,
      label: P.CREATOR_GRID.label,
      imagePath: 'https://cdn-www.topfans.com/TopFans/1785500807354.png',
      description: P.CREATOR_GRID.description
    },
    {
      id: LAYOUT_IDS.PASSION_GRID_LAYOUT,
      label: PASSION_GRID_LAYOUT_CONSTANTS.LAYOUT_LABEL,
      imagePath: PASSION_GRID_LAYOUT_CONSTANTS.LAYOUT_IMAGE_PATH,
      description: PASSION_GRID_LAYOUT_CONSTANTS.LAYOUT_DESCRIPTION
    },
    {
      id: LAYOUT_IDS.FEATURE_LIST_IMAGE_LAYOUT,
      label: FEATURE_LIST_IMAGE_LAYOUT_CONSTANTS.LAYOUT_LABEL,
      imagePath: FEATURE_LIST_IMAGE_LAYOUT_CONSTANTS.LAYOUT_IMAGE_PATH,
      description: FEATURE_LIST_IMAGE_LAYOUT_CONSTANTS.LAYOUT_DESCRIPTION
    },
    {
      id: LAYOUT_IDS.TESTIMONIAL_LAYOUT,
      label: C.TESTIMONIAL.label,
      imagePath: 'https://cdn-www.topfans.com/TopFans/1774943781458.png',
      description: C.TESTIMONIAL.description
    }
  ];

export const MARKETING_PRO_PAGE_LAYOUTS: MarketingPageSectionLayout[] =
  [
    ...MARKETING_PRO_PAGE_RECOMMENDED_LAYOUTS,
    ...MARKETING_COMPARISON_PAGE_RECOMMENDED_LAYOUTS,
    ...MARKETING_LISTING_PAGE_LAYOUTS
  ];

/** Deduplicated union of listing, comparison, and pro layouts for White-Label Cover Page CMS. */
export const WHITELABEL_COVER_PAGE_LAYOUTS: MarketingPageSectionLayout[] = Array.from(
  new Map(
    [
      ...MARKETING_LISTING_PAGE_LAYOUTS,
      ...MARKETING_COMPARISON_PAGE_RECOMMENDED_LAYOUTS,
      ...MARKETING_PRO_PAGE_RECOMMENDED_LAYOUTS,
      ...MARKETING_EVENT_TICKETING_PAGE_LAYOUTS,
      ...MARKETING_VIP_OFFER_PAGE_LAYOUTS,
      ...MARKETING_FEED_PAGE_LAYOUTS,
      ...MARKETING_PORTFOLIO_PAGE_LAYOUTS
    ]
      .filter((layout) => !MARKETING_PAGE_SECTION_EXCLUDED_LAYOUT_ID_SET.has(layout.id))
      .map((layout) => [layout.id, layout])
  ).values()
);
